import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Alert, Card, Modal, ModalBody, ModalHeader } from "reactstrap"
import EndDialogContent from "../EndDialogContent"
import styles from "./BottomAlert.module.scss"

function BottomAlert({ onlyInternet = false }) {
	const [isModalOpen, setIsModalOpen] = useState(!onlyInternet)
	const spectate = localStorage.getItem("spectate")

	const { isPaused, notStarted, isDisconnected } = useSelector((state) => {
		return {
			isPaused: state.time.isPaused,
			notStarted: state.time.notStarted,
			isDisconnected: state.isDisconnected,
		}
	})

	if (!onlyInternet) {
		useEffect(() => {
			if (notStarted) setIsModalOpen(true)
		}, [notStarted])
	}
	if (!isPaused && !isDisconnected) return <></>

	return (
		<div className={styles.bottomPadding}>
			<div className={styles.fixed}>
				{isDisconnected ? (
					<Card style={{height: "100vh"}}>
						<Alert color="danger" style={{margin: "auto"}} className={styles.alert}>
							<h1 className="alert-heading">
								Niste spojeni na internet. Ponovno se spojite na internet ako želite uređivati evente.
							</h1>
							<p className="alert-body">
								Korisnici koji nisu spojeni na internet ne mogu dodavati, brisati ni mjenjati evente.
							</p>
							
						</Alert>
					</Card>
				) : isPaused && !onlyInternet && !spectate ? (
					<Card>
						<Alert color="warning" className={styles.alert}>
							<h1 className="alert-heading">Upozorenje</h1>
							<p className="alert-body">Utakmica je pauzirana.</p>
						</Alert>
					</Card>
				) : (
					<></>
				)}
				<Modal
					isOpen={isModalOpen}
					toggle={() => setIsModalOpen(false)}
					className="modal-dialog-centered modal-sm"
				>
					<ModalHeader toggle={() => setIsModalOpen(false)}>
						Gotovo poluvrijeme
					</ModalHeader>
					<ModalBody className={styles.popup}>
						<EndDialogContent
							dismissModal={() => setIsModalOpen(false)}
						/>
					</ModalBody>
				</Modal>
			</div>
		</div>
	)
}

export default BottomAlert
